<template>
  <div id="dialog-consulting-case">
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <template v-slot:activator="{ on }">
        <v-btn @click="addItem()" color="primary" dark v-on="on">Create</v-btn>
      </template>
      <v-card>
        <!-- <v-card-title>
          <h1 class="title head-page">Counsulting Topic</h1>
        </v-card-title>-->
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-xs>
            <v-layout align-center justify-center row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="beneficiarys"
                  clearable
                  item-text="name"
                  item-value="idx"
                  label="Beneficiary"
                  v-model="formData.consultingBeneficiaryId"
                ></v-autocomplete>
                <v-autocomplete
                  :items="users"
                  clearable
                  item-text="fullname"
                  item-value="userid"
                  label="User"
                  v-model="formData.userId"
                ></v-autocomplete>
                <v-textarea clearable label="Problems" v-model="formData.problems"></v-textarea>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  full-width
                  lazy
                  min-width="290px"
                  offset-y
                  transition="scale-transition"
                  v-model="menuDate"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      clearable
                      label="Date"
                      readonly
                      v-model="formData.acceptDate"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    @input="menuDate = false"
                    no-title
                    v-model="formData.acceptDate"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="formData.acceptTime"
                  full-width
                  lazy
                  max-width="290px"
                  min-width="290px"
                  offset-y
                  ref="menu"
                  transition="scale-transition"
                  v-model="menuTime"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      clearable
                      label="Time"
                      readonly
                      v-model="formData.acceptTime"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    @click:minute="$refs.menu.save(formData.acceptTime)"
                    format="24hr"
                    full-width
                    v-if="menuTime"
                    v-model="formData.acceptTime"
                  ></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <base-delete-button :idx="formData.idx" module="ConsultingCase"></base-delete-button>
          <v-spacer></v-spacer>
          <v-btn @click.stop="dialogItem = !dialogItem" color dark>Close</v-btn>
          <v-btn :loading="dialogLoading" @click.prevent="doSubmit()" color="green" dark
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'dialog-consulting-case',
  data() {
    return {
      formData: [],
      dialogLoading: false,
      users: [],
      menuDate: false,
      menuTime: false
    }
  },
  watch: {
    dialogItem() {
      if (this.$store.state.ConsultingCase.idx) {
        this.formData = this.$store.getters['ConsultingCase/getAll'].filter(
          item => item.idx == this.$store.state.ConsultingCase.idx
        )[0]
      } else {
        this.formData = []
      }
    }
  },
  computed: {
    beneficiarys() {
      return this.$store.getters['ConsultingBeneficiary/getAll']
    },
    dialogItem: {
      // getter
      get() {
        return this.$store.state.ConsultingCase.dialog
      },
      // setter
      set(newValue) {
        this.$store.commit('ConsultingCase/UPDATE_DIALOG', newValue)
      }
    }
  },
  created() {
    this.getUsers()
  },
  methods: {
    async getUsers() {
      try {
        const response = await this.axios.get(`farmerspace/users`)
        this.users = response.data
      } catch (error) {
        throw new Error(error)
      }
    },
    async doSubmit() {
      try {
        const validate = await this.$validator.validateAll()
        if (validate) {
          this.dialogLoading = !this.dialogLoading
          const data = {
            ...this.formData,
            createdBy: localStorage.getItem('tokenAdmin')
          }
          this.formData.idx
            ? await this.$store.dispatch(`ConsultingCase/update`, data)
            : await this.$store.dispatch(`ConsultingCase/insert`, data)
          this.$store.commit(`ConsultingCase/UPDATE_DIALOG`, false)
          this.formData = []
          this.dialogLoading = !this.dialogLoading
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    addItem() {
      this.$store.commit('ConsultingCase/UPDATE_DIALOG', true)
      this.$store.commit('ConsultingCase/SET_IDX', null)
    }
  }
}
</script>

<style lang="scss" scoped></style>
